// Trial quotas, mirrored from server/src/services/trialLimits.service.js (the server enforces them).
export const TRIAL_LEAD_LIMIT = 50;

/** Toast text for campaign leads the server skipped because the trial quota is full, or null. */
export function trialLeadSkipMessage(skipped = []) {
  const count = skipped.filter((item) => item?.reason === "TRIAL_LIMIT_REACHED").length;
  if (count === 0) return null;
  return `${count} contact${count !== 1 ? "s were" : " was"} not added: your trial includes ${TRIAL_LEAD_LIMIT} campaign leads. Upgrade to add more.`;
}

/**
 * For a response that hit a trial limit or a paid-only feature: the text for the upgrade
 * prompt (null = the default paid-only text). undefined for every other response.
 * Some endpoints only forward the message, so "Trial limit reached" text counts too.
 */
export function trialUpgradeMessage(response) {
  const status = response?.status;
  const { code, error } = response?.data || {};
  if (status === 403 && code === "upgrade_required") return null;
  if (status !== 400) return undefined;
  if (/^TRIAL_.*LIMIT_EXCEEDED$/.test(code || "") || /^Trial (limit reached|users can connect only)/.test(error || "")) {
    return error || "You've used everything included in your trial. Upgrade to continue.";
  }
  return undefined;
}
